import { defineStore } from "pinia"
import { ProjectPurchaseItem } from "@/models/project-purchase-item.model"
import { ref, type Ref } from "vue"
import { usePriceAgreementsConstantTimeLookup } from "@/composables/store/price-agreements-constant-time-lookup"

export const useProjectsPurchaseItemsStore = defineStore("projectPurchaseItemsStore", () => {
  const projectsPurchaseItems: Ref<ProjectPurchaseItem[]> = ref([])

  const { getPriceAgreement, getUnitPrice } =
    usePriceAgreementsConstantTimeLookup<ProjectPurchaseItem>(
      projectsPurchaseItems,
      (item) => [item.project, item.purchaseItem],
      (item) => item.unitPrice
    )

  return {
    projectsPurchaseItems,
    getPriceAgreement,
    getUnitPrice
  }
})
